"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const RouteInterceptor_1 = require("../RouteInterceptor");
/**
 * @category Component
 * @example Usage
 * ```typescript
    import { SessionContext } from "@mne-authentication/session2";

    const routeDefinitions: Array<TRouteDefinition<{ session: ISession }>> = [
        ... // other routes
        {
          path: "customer/:customerId/overview",
          exact: true,
          component: PagesV1.OverviewLazyLoader,
          loader: Loaders.OverviewSkeleton,
          interceptors:  ....
        }
      ];


    const Content = () => {
        // Example use of context, you can add whatever else you want to it
        // and then you can access the context inside your interceptors.
        
        const { session } = useContext(SessionContext)
        const context = { session }

        return (
            <Routes context={context} routeDefinitions={routeDefinitions} />
        )
    }
 * ```
 */
const Routes = ({ routeDefinitions, context, ...restProps }) => (react_1.default.createElement(react_router_dom_1.Routes, null, routeDefinitions.map((routeDefinition) => (react_1.default.createElement(react_router_dom_1.Route, { key: routeDefinition.path, path: routeDefinition.path, element: react_1.default.createElement(RouteInterceptor_1.RouteInterceptor, { ...restProps, context: context, routeDefinition: routeDefinition }) })))));
exports.default = Routes;
